import { render, staticRenderFns } from "./CardColumnSelector.vue?vue&type=template&id=a235ad88"
import script from "./CardColumnSelector.vue?vue&type=script&lang=ts"
export * from "./CardColumnSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports